import { BiHelpCircle, BiHomeAlt } from 'react-icons/bi'
import { BsCalendarDate } from 'react-icons/bs'

import { ILink } from '@base/@types/components/Layout/Navigator'

import adminLinks from './admin'
import alertLinks from './alert'
// import assortmentLinks from './assortment'
import budgetLinks from './budget'
import kpiLinks from './kpi'
import mrpLinks from './mrp'
import optimizerLinks from './optimizer'
import otbLinks from './otb'
import parametrizationLinks from './parametrization'

// const email = decodedToken ? decodedToken.email : ''
// eslint-disable-next-line react-hooks/rules-of-hooks

const links: ILink[] = [
  {
    group: 'Início',
    icon: <BiHomeAlt />,
    path: '/'
  },
  kpiLinks,
  parametrizationLinks,
  mrpLinks,
  alertLinks,
  budgetLinks,
  // assortmentLinks,
  otbLinks,
  optimizerLinks,
  adminLinks,

  {
    group: 'Agendamento',
    icon: <BsCalendarDate />,
    path: process.env.REACT_APP_URL_SCHENDULER,
    external: true
  },
  {
    group: 'Ajuda',
    icon: <BiHelpCircle />,
    path: '/ajuda'
  }
]

export default links
